import React from "react";
import { TrendingDown, Zap, BadgeCheck, Eye, Workflow, LayoutGrid } from "lucide-react";
import { Reveal, SectionHeading, cardBase } from "./primitives";

const OUTCOMES = [
  { icon: TrendingDown, stat: "0%", title: "Factory Direct Prices", body: "No product markups. Buy straight from the manufacturer at true factory pricing." },
  { icon: Zap, stat: "1", title: "Bulk Purchasing Efficiency", body: "Consolidate large-volume orders with a single manufacturer in one place." },
  { icon: BadgeCheck, stat: "100%", title: "Verified Manufacturers", body: "Every supplier is vetted and verified before you commit a bulk order." },
  { icon: Eye, stat: "24/7", title: "Production Transparency", body: "Real-time production progress, capacity and completion estimates." },
  { icon: Workflow, stat: "8→1", title: "Reduced Coordination Effort", body: "Replace scattered tools and threads with one connected workflow." },
  { icon: LayoutGrid, stat: "1", title: "One Workspace", body: "Documents, milestones and communication unified for every order." },
];

export default function Outcomes() {
  return (
    <section id="outcomes" className="bg-[#F8FAFC] py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Business Outcomes"
            title="Procurement control that shows up on the bottom line."
            subtitle="BulkContainer™ turns complex factory-direct sourcing into a measurable, repeatable operation."
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {OUTCOMES.map((o, i) => (
            <Reveal key={o.title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`outcome-card-${i}`}
                className={`${cardBase} h-full p-7 transition-transform duration-300 hover:-translate-y-1`}
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#EBF2FF] text-[#0052FF]">
                    <o.icon className="h-5 w-5" />
                  </span>
                  <span className="font-display text-2xl font-extrabold text-[#0A1128]">{o.stat}</span>
                </div>
                <h3 className="font-display mt-5 text-base font-bold text-[#0A1128]">{o.title}</h3>
                <p className="mt-2 text-[14px] leading-relaxed text-[#64748B]">{o.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
